<template>
  <v-row class="row--35" align="center">
    <v-col lg="6" md="6" cols="12">
      <div class="thumbnail">
        <img
          class="w-100"
          src="../../assets/images/about/ai2.jpg"
          alt="About Images"
        />
      </div>
    </v-col>
    <v-col lg="6" md="6" cols="12">
      <div class="about-inner inner">
        <div class="section-title text-left">
          <h2 class="heading-title" style="color: #fff">Self Managed HOAs</h2>
          <h3 style="color: #fff">Take your HOA digital.</h3>
          <p style="color: #fff">
            Less manual work, more automation, top class reporting and a free employee with Emerie.AI finishing time consuming tasks for you.
          </p>
        </div>
        <div class="rn-accordion mt--20">
          <SelfManagedAccordian />
        </div>

        <div class="about-button mt--50">
          <a class="rn-button-style--2 btn_solid" href="/contact"
            >Stay in touch for the beta</a
          >
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
  import SelfManagedAccordian from "../../components/accordion/SelfManagedAccordian";
  import ManagedAccordian from "../../components/accordion/ManagedAccordian";
  export default {
    components: {
      SelfManagedAccordian,
      ManagedAccordian
    },
    data() {
      return {};
    },
  };
</script>
